import { PlatformType } from '../platform/definitions';
import EnvHelper from './appEnvironmentHelper';

export default class UAHelper {
  private static userAgent = UAHelper.getUserAgent();
  static getUserAgent() {
    return EnvHelper.getUserAgentString();
  }

  private static platform = {
    [PlatformType.ANDROID]: UAHelper.isPlatform(
      PlatformType.ANDROID,
      /Android\/Mobile/i
    ),
    [PlatformType.IOS]: UAHelper.isPlatform(
      PlatformType.IOS,
      /fk_ios_app FKUA/i
    ),
    [PlatformType.WINDOWS]: UAHelper.isPlatform(
      PlatformType.WINDOWS,
      /fk_windows_app/i
    ),
    [PlatformType.WEB]: UAHelper.isPlatform(PlatformType.WEB, /msite\/Mobile/i),
    [PlatformType.DESKTOP]: UAHelper.isPlatform(
      PlatformType.DESKTOP,
      /website\/Desktop/i
    )
  };
  private static isPlatform(platform: PlatformType, regex: RegExp): boolean {
    return (
      EnvHelper.getPlatformString() === platform ||
      regex.test(UAHelper.userAgent)
    );
  }
  static isAndroid() {
    return UAHelper.platform[PlatformType.ANDROID];
  }

  static isIOS() {
    return UAHelper.platform[PlatformType.IOS];
  }

  static isWindows() {
    return UAHelper.platform[PlatformType.WINDOWS];
  }

  static isDesktop() {
    return UAHelper.platform[PlatformType.DESKTOP];
  }

  static isMSite(): boolean {
    return (
      UAHelper.platform[PlatformType.WEB] ||
      // Currently any other platform which is not Android/iOS/Windows is treated as web
      !(UAHelper.isIOS() || UAHelper.isAndroid() || UAHelper.isWindows())
    );
  }

  static getResolvedPlatformString() {
    const { platform } = UAHelper;

    if (platform[PlatformType.ANDROID]) {
      return PlatformType.ANDROID;
    }

    if (platform[PlatformType.IOS]) {
      return PlatformType.IOS;
    }

    if (platform[PlatformType.WINDOWS]) {
      return PlatformType.WINDOWS;
    }

    return PlatformType.WEB;
  }
}
